import { utcDateTime } from './utc-date-time';

export const isDatesEqualInUTC = (isoDate1: string, isoDate2: string) =>
  utcDateTime(isoDate1).toISODate() === utcDateTime(isoDate2).toISODate();
